import { FC } from 'react';
import { ReactComponent as FavoriteOff } from '../../Images/favorite_off.svg';
import { ReactComponent as FavoriteOn } from '../../Images/favorite_on.svg';

interface Props {
    isFavorite: boolean;
}

const FavoriteIndicator: FC<Props> = ({ isFavorite }) => {
    if (isFavorite) {
        return <FavoriteOn />;
    }

    return <FavoriteOff />;
};

export default FavoriteIndicator;
